import React, { useState, useEffect } from "react";



import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import db from "./Firebase"

const RemoveDuplicatePhoneNumbers = () => {

    const bulkUpdateQuizId = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, "workshop_event_data"));
            let updatedCount = 0;

            // Loop through documents
            for (const document of querySnapshot.docs) {
                const data = document.data();

                // Check if expert is "deepak"
                if (data.expert === "Deepak Baluja") {
                    const docRef = doc(db, "workshop_event_data", document.id);

                    // Update or create quiz_id
                    await updateDoc(docRef, { expert_id: "e3" });

                    updatedCount++;
                }
            }

            alert(`Bulk update completed! Updated ${updatedCount} records.`);
        } catch (error) {
            console.error("Error in bulk update:", error);
            alert("Failed to update records.");
        }
    };



    return (
        <div className="p-4">
            <h2 className="text-xl font-bold mb-4">Duplicate Phone Numbers (+91 versions)</h2>

            <button onClick={bulkUpdateQuizId} className="bg-blue-500 text-white px-4 py-2 rounded">
                Bulk Update expert_id IDs
            </button>
        </div>
    );
};

export default RemoveDuplicatePhoneNumbers;
